import { Observable } from 'rxjs'
import { Country } from '@spartacus/core'

export abstract class MbCountriesNoAccountAdapter {

  abstract load(): Observable<Country[]>
}
